import * as moment from 'moment'
import * as omit from 'lodash/omit'
import * as styles from 'styles/pages/Styleguide.css'
import ModuleHeader, { ModuleHeaderProps } from 'components/features/pfm/ModuleWrapper/ModuleHeader'
import AccountBadge, { AccountBadgeProps } from 'components/features/pfm/AccountBadge/AccountBadge'
import { DATE_FORMAT_US } from 'constants/datetime'
import { TooltipIcon } from 'components/features/pfm/Tooltip/TooltipIcon'
import DescriptionList, { DescriptionItemType } from 'components/atoms/DescriptionList'

const moduleHeaderProps: ModuleHeaderProps = {
  hint: 'This is a hint!',
  title: 'An important module title',
  subtitle: 'An the subtitle is here',
  titleLinkTo: 'about',
}

const accountBadgeProps: AccountBadgeProps = {
  name: 'Chase Credit',
  cardNumber: '1234',
  cardType: 'Visa',
  updatedAt: moment().format(DATE_FORMAT_US),
  tooltipChild: (
    <TooltipIcon theme='danger'>
      Very important message.
    </TooltipIcon>
  ),
}

const descriptionListItems: DescriptionItemType[] = [
  { label: 'Your name', value: 'Majd Maksad', hint: 'That\'s a really cool name!' },
]

const EXAMPLES = [
  <ModuleHeader key={ 0 } { ...moduleHeaderProps } />,
  <ModuleHeader key={ 1 } { ...omit(moduleHeaderProps, 'titleLinkTo') } />,
  <ModuleHeader key={ 2 } { ...omit(moduleHeaderProps, ['titleLinkTo', 'subtitle']) } />,
  <AccountBadge key={ 3 } { ...accountBadgeProps } />,
  <DescriptionList key={ 4 } items={ descriptionListItems } />,
]

const SGTooltips = () => {
  return (
    <section className={ styles.sgSection }>
      { EXAMPLES.map((example, idx) => (
        <div key={ idx } className={ styles.sgExample }>
          { example }
        </div>
      ))}
    </section>
  )

}
export default SGTooltips

